module.exports = __webpack_public_path__ + "media/images/logo-light-916ed6fa4dc182aeb7402173cab5ce2b.png";